export const frontdeskEn = {
  "frontdesk.nav.desk": "Front desk",
  "frontdesk.nav.desks": "Desks",

  "frontdesk.title": "Front desk",
  "frontdesk.subtitle": "Arrivals and the state of the systems, for the desk you work at.",
  "frontdesk.picker": "Desk",
  "frontdesk.none.title": "No desk to show",
  "frontdesk.none.manager": "No desk is set up yet. Set one up now with the usual arrivals, clock and status, or create your own under Desks.",
  "frontdesk.none.setUp": "Set up a front desk",
  "frontdesk.none.defaultName": "Front desk",
  "frontdesk.none.staff": "You are not assigned to a desk yet. Ask a manager to add you to one.",
  "frontdesk.desk.noWidgets": "This desk has no widgets yet. A manager can add some with Edit desk layout.",
  "frontdesk.desk.allHidden": "You have hidden every widget on this desk. Use Customize to show them again.",

  "frontdesk.widget.arrivals": "Arrivals",
  "frontdesk.widget.system_status": "System status",
  "frontdesk.widget.clock": "Clock",
  "frontdesk.widget.notes": "Desk notes",
  "frontdesk.widget.call_log": "Call log",
  "frontdesk.widget.lightning": "Lightning",
  "frontdesk.widget.camera": "Camera",
  "frontdesk.placeholder": "This widget arrives in a later update.",

  "frontdesk.callLog.needAccess": "You need permission to read the call log.",
  "frontdesk.callLog.none": "No calls yet.",
  "frontdesk.callLog.unknown": "Unknown caller",
  "frontdesk.callLog.openLog": "Open the call log",
  "frontdesk.callLog.direction.inbound": "Incoming",
  "frontdesk.callLog.direction.outbound": "Outgoing",
  "frontdesk.callLog.direction.internal": "Internal",

  "frontdesk.arrivals.dayControls": "Choose the day",
  "frontdesk.arrivals.previousDay": "Previous day",
  "frontdesk.arrivals.nextDay": "Next day",
  "frontdesk.arrivals.today": "Today",
  "frontdesk.arrivals.backToToday": "Back to today",
  "frontdesk.arrivals.none": "Nobody is expected on this day.",
  "frontdesk.arrivals.noTime": "Any time",
  "frontdesk.arrivals.host": "Host: {name}",
  "frontdesk.arrivals.kind.guest": "Guest",
  "frontdesk.arrivals.kind.lodging": "Room stay",
  "frontdesk.arrivals.kind.event": "Event",
  "frontdesk.arrivals.kind.dining": "Dining",
  "frontdesk.arrivals.status.expected": "Expected",
  "frontdesk.arrivals.status.arrived": "Arrived",
  "frontdesk.arrivals.status.departed": "Departed",
  "frontdesk.arrivals.status.no_show": "No-show",

  "frontdesk.status.label.database": "Database",
  "frontdesk.status.label.installation": "Installation",
  "frontdesk.status.label.licence": "License",
  "frontdesk.status.label.email": "Email",
  "frontdesk.status.label.lightning": "Lightning",
  "frontdesk.status.label.pbx": "Phone system",
  "frontdesk.status.label.cameras": "Cameras",
  "frontdesk.status.state.ok": "OK",
  "frontdesk.status.state.warning": "Needs attention",
  "frontdesk.status.state.error": "Problem",
  "frontdesk.status.state.not_configured": "Not set up",
  "frontdesk.status.checked": "Checked at {time}",

  "frontdesk.clock.zone": "Club time ({zone})",
  "frontdesk.notes.empty": "No notes for this desk yet.",

  "frontdesk.customise.open": "Customize",
  "frontdesk.customise.title": "Customize {desk}",
  "frontdesk.customise.description": "Choose which widgets you see on this desk and how big they are. It affects only your own screen.",
  "frontdesk.customise.reset": "Reset to the desk's layout",
  "frontdesk.customise.empty": "This desk has no widgets to customize.",
  "frontdesk.customise.show": "Show {widget}",
  "frontdesk.customise.width": "Width (columns)",
  "frontdesk.customise.height": "Height (rows)",

  "frontdesk.layout.edit": "Edit desk layout",
  "frontdesk.layout.title": "Layout of {desk}",
  "frontdesk.layout.subtitle": "The screen is {columns} columns wide. Everyone at this desk sees this layout and can hide or resize widgets for themselves.",
  "frontdesk.layout.back": "Back to the front desk",
  "frontdesk.layout.save": "Save layout",
  "frontdesk.layout.saved": "Layout saved.",
  "frontdesk.layout.addGroup": "Add a widget",
  "frontdesk.layout.type": "Widget",
  "frontdesk.layout.add": "Add widget",
  "frontdesk.layout.noRoom": "There is no room for another widget of that size. Remove one or make one smaller first.",
  "frontdesk.layout.empty": "This layout is empty. Add a widget to start.",
  "frontdesk.layout.list": "Widgets in this layout",
  "frontdesk.layout.remove": "Remove {widget}",
  "frontdesk.layout.column": "Column",
  "frontdesk.layout.row": "Row",
  "frontdesk.layout.width": "Width (columns)",
  "frontdesk.layout.height": "Height (rows)",
  "frontdesk.layout.notesText": "Text of {widget}",
  "frontdesk.problem.tooMany": "A layout can hold at most {max} widgets.",
  "frontdesk.problem.tooWide": "The widget \"{id}\" runs past column {columns}. Move it left or make it narrower.",
  "frontdesk.problem.tooLow": "The widget \"{id}\" runs past row {rows}. Move it up or make it shorter.",
  "frontdesk.problem.overlap": "The widgets \"{a}\" and \"{b}\" overlap. Move one of them.",

  "frontdesk.desks.title": "Desks",
  "frontdesk.desks.subtitle": "The screens your staff work from, who works at each, and how each one is laid out.",
  "frontdesk.desks.new": "New desk",
  "frontdesk.desks.rename": "Change {desk}",
  "frontdesk.desks.name": "Name",
  "frontdesk.desks.description": "Description",
  "frontdesk.desks.nameRequired": "Give the desk a name.",
  "frontdesk.desks.empty": "No desks yet",
  "frontdesk.desks.emptyBody": "Create a desk such as Front desk or Pro shop, then arrange its screen and choose who works there.",
  "frontdesk.desks.staff": "Staff",
  "frontdesk.desks.staffCount_one": "{count} person",
  "frontdesk.desks.staffCount_other": "{count} people",
  "frontdesk.desks.state": "State",
  "frontdesk.desks.actions": "Actions",
  "frontdesk.desks.active": "Active",
  "frontdesk.desks.inactive": "Inactive",
  "frontdesk.desks.renameButton": "Change",
  "frontdesk.desks.renameOf": "Change {desk}",
  "frontdesk.desks.staffButton": "Staff",
  "frontdesk.desks.staffOf": "Choose the staff of {desk}",
  "frontdesk.desks.layoutButton": "Layout",
  "frontdesk.desks.layoutOf": "Edit the layout of {desk}",
  "frontdesk.desks.deactivate": "Deactivate {desk}",
  "frontdesk.desks.activate": "Activate {desk}",
  "frontdesk.desks.staffTitle": "Staff at {desk}",
  "frontdesk.desks.staffHelp": "Tick the people who work at this desk. They then see it on their Front desk screen.",
  "frontdesk.desks.staffList": "Club users",

  "apiError.desk_name_taken": "Another desk already has this name.",
  "apiError.desk_not_found": "That desk no longer exists. Reload to see the current desks.",
  "apiError.club_user_not_found": "That person is no longer a user of this club.",
  "apiError.not_at_desk": "That person is not assigned to this desk.",
  "apiError.prefs_do_not_fit": "Those choices do not fit the screen. Hide a widget that is in the way, or make one smaller.",
} as const;

export type FrontdeskMessages = typeof frontdeskEn;
